import type { TrialResearchLocation } from '../types';

export function trialLocationNames(locations: TrialResearchLocation[] = []): string[] {
  return locations.map((location) => location.name.trim()).filter(Boolean);
}

export function trialLocationSummary(names: string[], max = 3): string | null {
  if (!names.length) return null;

  const shown = names.slice(0, max).join(', ');

  return names.length > max ? `${shown}…` : shown;
}
